import { useQuery } from '@tanstack/react-query'

import type { SettingsRepository } from './settings-repository'

export function useClinicProfile(
  repository: SettingsRepository,
  tenantId: string
) {
  return useQuery({
    queryKey: ['settings', tenantId, 'clinic-profile'],
    queryFn: () => repository.getClinicProfile(tenantId),
  })
}
